<div class="result-details">
  @for (item of items(); track $index) {
    <div
      class="result-row result-row--clickable"
      role="button"
      tabindex="0"
      [attr.aria-label]="'Open larger preview of ' + item.displayName"
      (click)="openPreview(item)"
      (keydown.enter)="openPreviewFromKeyboard($event, item)"
      (keydown.space)="openPreviewFromKeyboard($event, item)">
      <h2 class="label">{{ item.displayName }}</h2>
      <div class="result-content">
        @switch (item.kind) {
          @case ('value') {
            <span class="value">{{ valueText(item.value) }}</span>
          }
          @case ('text') {
            <div class="text-output-content" [innerText]="item.text"></div>
          }
          @case ('image') {
            <div class="result-image">
              <img [src]="item.src" [alt]="item.displayName" class="result-img" />
            </div>
          }
          @case ('file') {
            <div class="result-file">
              <span class="material-symbols-outlined">description</span>
              <span class="result-file__name">{{ item.fileName }}</span>
            </div>
          }
          @case ('file-loading') {
            @if (item.image) {
              <div class="result-image" aria-label="Loading image"></div>
            } @else {
              <div class="result-file" aria-label="Loading file">
                <span class="result-file-icon-placeholder"></span>
                <span class="result-file-name-placeholder">
                  <span>{{ item.fileName }}</span>
                </span>
              </div>
            }
          }
          @case ('table') {
            <div class="result-table-preview" aria-hidden="true" inert>
              <app-dynamic-table
                [allowEdit]="false"
                [columns]="item.columnDef"
                [data]="item.tableData"></app-dynamic-table>
            </div>
          }
          @case ('graph') {
            <app-graph [chartOptions]="item.options"></app-graph>
          }
        }
      </div>
    </div>
  }
</div>
